import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  > * {
    margin-top: ${(props) => props.theme.space.md};
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      margin-top: 1.25rem;
    }
  }
  > .heading,
  > .leadershipAnchor {
    margin-top: 0;
  }
  .description {
    margin-top: ${(props) => props.theme.space.sm};
  }
`;
